import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-16">
      <div className="max-w-2xl w-full text-center">
        {/* Icon */}
        <div className="mb-8 flex justify-center">
          <div className="w-32 h-32 flex items-center justify-center bg-gray-100 rounded-full">
            <i className="ri-error-warning-line text-6xl text-gray-400"></i>
          </div>
        </div>

        {/* 404 Title */}
        <h1 className="text-8xl font-bold text-gray-900 mb-4">{t('common.404.subtitle')}</h1>

        {/* Subtitle */}
        <h2 className="text-3xl font-semibold text-gray-800 mb-6">
          {t('common.404.title')}
        </h2>

        {/* Description */}
        <p className="text-lg text-gray-600 mb-12 max-w-md mx-auto">
          {t('common.404.description')}
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-8 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line mr-2"></i>
            {t('common.actions.back_home')}
          </Link>
          <Link
            to="/products"
            className="inline-flex items-center justify-center px-8 py-3 bg-white text-teal-600 font-medium rounded-lg border-2 border-teal-600 hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            {t('common.actions.browse_products')}
          </Link>
        </div>

        {/* Additional Help Links */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">{t('common.404.help_text', { defaultValue: 'Need help? Try these:' })}</p>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link to="/brands" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              {t('nav.brands')}
            </Link>
            <Link to="/categories" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              {t('nav.categories')}
            </Link>
            <Link to="/cart" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              {t('nav.cart')}
            </Link>
            <Link to="/account/orders" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              {t('nav.my_orders')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
